/* lua.js generated code 0.3.0 */

require("clover/data/MetaRef")
require("clover/data/MaintenanceManager")

var debugMetaData = false
var instance = null
MetaManager = table()
MetaManager.getInstance = function () {
    if (!instance) {
        instance = MetaManager
    }
    return instance
}
function parseItemDict(meta_client, childName, cls) {
    var result = table()
    var xmlList = meta_client[childName]
    if (xmlList) {
        for (var i in xmlList) {
            var v = xmlList[i]
            if (!v) {
                continue
            }
            var p = cls.new()
            p.fromLua(v)
            if (p.id) {
                result[p.id] = p
            }else if (p.levelId) {
                result[p.levelId] = p
            }
        }
    } else {
        TODO("parseItemDict: childName = " + childName)
    }
    return result
}
var MetaKeyClassList = table(
    [0, table([1, "key", "level"], [1, "cls", LevelMetaRef])],
    [0, table([1, "key", "level_area"], [1, "cls", LevelAreaMetaRef])],
    [0, table([1, "key", "branch_level"], [1, "cls", HideAreaMetaRef])],
    [0, table([1, "key", "level_reward"], [1, "cls", LevelRewardMetaRef])],
    [0, table([1, "key", "invite_reward"], [1, "cls", InviteRewardMetaRef])],
    [0, table([1, "key", "invite_count_reward"], [1, "cls", InviteCountRewardMetaRef])],
    [0, table([1, "key", "ladybug_reward"], [1, "cls", LadybugRewardMetaRef])],
    [0, table([1, "key", "freegift"], [1, "cls", FreegiftMetaRef])],
    [0, table([1, "key", "achi"], [1, "cls", AchiMetaRef])],
    [0, table([1, "key", "qq_game_vip_daily_reward"], [1, "cls", QgameVipDailyRewardMetaRef])],
    [0, table([1, "key", "qq_vip_daily_reward"], [1, "cls", QqVipDailyRewardMetaRef])],
    [0, table([1, "key", "activity_rewards"], [1, "cls", ActivityRewardsMetaRef])],
    [0, table([1, "key", "rewards"], [1, "cls", RewardsRef])],
    [0, table([1, "key", "gamemode_prop"], [1, "cls", GameModePropMetaRef])],
    [0, table([1, "key", "goods"], [1, "cls", GoodsMetaRef])],
    [0, table([1, "key", "prop"], [1, "cls", PropMetaRef])],
    [0, table([1, "key", "goods_pay_code"], [1, "cls", GoodsPayCodeMetaRef])],
    [0, table([1, "key", "discount_notify"], [1, "cls", DiscountNotifyMetaRef])],
    [0, table([1, "key", "product_android"], [1, "cls", ProductMetaRef])],
    [0, table([1, "key", "product"], [1, "cls", ProductMetaRef])],
    [0, table([1, "key", "product_wechatgame"], [1, "cls", ProductMetaSubClassRef])],
    [0, table([1, "key", "mark"], [1, "cls", MarkMetaRef])],
    [0, table([1, "key", "deco"], [1, "cls", DecoMetaRef])],
    [0, table([1, "key", "func"], [1, "cls", FuncMetaRef])],
    [0, table([1, "key", "gift_blocker"], [1, "cls", GiftBlockerMetaRef])],
    [0, table([1, "key", "coin_blocker"], [1, "cls", CoinBlockerMetaRef])],
    [0, table([1, "key", "fruits_upgrade"], [1, "cls", FruitsUpgradeMetaRef])],
    [0, table([1, "key", "fruits"], [1, "cls", FruitsMetaRef])],
    [0, table([1, "key", "digger_match_rank_reward"], [1, "cls", DiggerMatchRankRewardMetaRef])],
    [0, table([1, "key", "digger_match_gem_reward"], [1, "cls", DiggerMatchGemRewardMetaRef])],
    [0, table([1, "key", "level_status"], [1, "cls", LevelStatusRef])],
    [0, table([1, "key", "vip_level"], [1, "cls", VipLevelMetaRef])],
    [0, table([1, "key", "cn_valentine"], [1, "cls", CnValentineMetaRef])],
    // [0, table([1, "key", "new_user_task"], [1, "cls", NewUserTaskMetaRef])],
    [0, table([1, "key", "prop_max_use"], [1, "cls", PropMaxUseMetaRef])],
    [0, table([1, "key", "guide_prop"], [1, "cls", GuidePropMetaRef])],
    [0, table([1, "key", "coupon"], [1, "cls", FriendCouponMetaRef])],
    //[0, table([1, "key", "constellation"], [1, "cls", StarGroupMetaRef])],
    [0, table([1, "key", "star_reward"], [1, "cls", StarRewardMetaRef])],
    [0, table([1, "key", "new_user_reward"], [1, "cls", NewUserRewardMetaRef])],
    [0, table([1, "key", "maintenance"], [1, "cls", MaintenanceMetaRef])],
    [0, table([1, "key", "intro"], [1, "cls", IntroMetaRef])],
    [0, table([1, "key", "head_frame"], [1, "cls", HeadFrameMetaRef])],
    [0, table([1, "key", "share_platform"], [1, "cls", WechatShareAppId])],
    // [0, table([1, "key", "rank_rewards"], [1, "cls", ActivityMissionRankRewards])],
    [0, table([1, "key", "icon"], [1, "cls", IconMeta])],
    [0, table([1, "key", "labels"], [1, "cls", LabelsMeta])],
    [0, table([1, "key", "level_difficulty"], [1, "cls", LevelHardnessMeta])],
    [0, table([1, "key", "drop_adjust"], [1, "cls", DropAdjustMetaRef])]
)
MetaManager.initialize = function () {
    var self = this
    var path = "packed/meta/meta_client.json"
    // let popout_test = global.popout_test;
    // let cube = "a";
    // if(popout_test) {
    //     cube = UserManager.getInstance().getGroupByKey(popout_test);
    // }
    const cube = UserManager.getInstance().getGroupByKey("popout_startpanel_test");
    console.log("PopoutMgr-cube:", cube);
    let popout_scene = cube != "d" ? "popout_scene_a" : "popout_scene_b";
    let popout_activity = cube != "d" ? "popout_activity_a" : "popout_activity_b";
    return CfgManager.load("goods","product_wechatgame","product_qq_lightgame", "product_oppo_quickgame", "product_baidu_lightgame", "game", "product_allplatform", "prop", "subscribe_msg", "new_ad_config", "ad_label", "ad_strategy", "ad_source_strategy", "battlepass_config","cube_ab_test","mysterious_island_common","month_ticket","shop","dress","prop_consume_value",popout_scene,popout_activity,
        "activity_rewards_convert"
    )
              .then((dataMap)=>{
                    let meta_content = cc.loader.getRes(path);
                    
                    let gameCfg = dataMap.get('game')
                    self.setPrePropsGuideConfig(gameCfg)
                    // 
                    self.setGameCfg(gameCfg)

                    //  新版商店信息
                    self.setCashConfig(gameCfg)

                    //  新版签到信息
                    self.loadNewMarkConfig(gameCfg)

                    //  Banner广告配置
                    self.loadBannerAdConfig(gameCfg);

                    //  格子广告配置
                    self.loadGridAdConfig(gameCfg);

                    //  插屏广告配置
                    self.loadInterstitialAdConfig(gameCfg);

                    //  定向分享配置
                    self.loadOrientedShareConfig(gameCfg);

                    //  关末奖励配置
                    self.loadPassLevelRewardConfig(gameCfg);

                    //  关末礼包配置
                    self.loadGiftBagConfig(gameCfg);

                    //  分享礼包配置
                    self.setRealShareConfig(gameCfg);

                    //  岛屿解锁配置
                    self.setIslandUnlockConfig(gameCfg);

                    //  ios支付引导配置
                    self.setPaymentGuideConfig(gameCfg);

                    //  手动定位配置i
                    self.setManualLocationConfig(gameCfg);

                    // 删除账号配置
                    self.setDeleteAccountConfig(gameCfg);

                    // iospay配置
                    self.setIosPayConfig(gameCfg);

                    // 关末加速配置
                    self.setBonusSpeed(gameCfg);

                    // 紫咪 开启分组
                    self.setPurpleAmyMagicOpenGroup(gameCfg);

                    // 兑换码开放渠道
                    self.setCdkeyPlatform(gameCfg)
                    
                    // 新增视频广告相关配置
                    self.setNewAdConfig(dataMap.get('new_ad_config'));

                    // 新增广告标签优化相关配置
                    self.setAdTagConfig(dataMap.get('ad_label'),dataMap.get('ad_strategy'),dataMap.get('ad_source_strategy'));

                    self.setCubeAbTestConfig(dataMap.get('cube_ab_test'));

                    //通行证相关配置
                    // require("activity/BattlePass/BattlePassLogic").getInstance().setConfig(dataMap.get('battlepass_config'))
                    self.setBattlePassConfig(dataMap.get('battlepass_config'));
                    
                    // 设置神秘岛相关配置
                    self.setMysteryIslandConfig(dataMap.get('mysterious_island_common'));

                    // 设置神秘岛相关配置
                    self.setMonthTicketConfig(dataMap.get('month_ticket'));

                    // 设置装扮相关配置
                    self.setDressConfig(dataMap.get('dress'));

                    // 设置商城相关配置
                    self.setShopConfig(dataMap.get('shop'));

                    // 设置道具消耗价值配置
                    self.setPropConsumeValueConfig(dataMap.get('prop_consume_value'));

                    
                    //设置权益卡强弹广告等级
                    self.setMonthTicketAdLevel(gameCfg);
                    //设置关末活动排序和奖励排序
                    self.setGameReviveCfg(gameCfg);

                    self.setAmyGiftCube(gameCfg);
                    self.setPopoutSceneCfg(dataMap.get(popout_scene))
                    self.setPopoutActivityCfg(dataMap.get(popout_activity))

                    // 设置联动活动奖励折算配置
                    self.setRewardConvertConfig(dataMap.get('activity_rewards_convert'));

                    

                    var confList = meta_content['global']
                    var conf = GlobalServerConfig.new()
                    conf.fromLua(confList)
                    self.global = conf
                    if (global.mini && mini.getPlatform() === MiniPlatform.qqlightGame) {
                        self.global.displayRank = gameCfg.qq_lightgame_rank_display
                    }else{
                        self.global.displayRank = true
                    }

                    //订阅配置
                    let subscribeCfg = dataMap.get('subscribe_msg')
                    console.log("@@@@subscribe cfg:", subscribeCfg)
                    if (subscribeCfg && subscribeCfg.subscription_switch){
                        let len = $len(subscribeCfg.subscription_switch)
                        self.subscribeOpenInfo = {}
                        for (let i = 0; i < len; ++i){
                            let tmpStrList = subscribeCfg.subscription_switch[i].split(':')
                            if ($len(tmpStrList) == 2)
                                self.subscribeOpenInfo[tmpStrList[0]] = tmpStrList[1]
                        }
                    }

                    //  覆盖prop
                    meta_content['prop'] = dataMap.get('prop')
                    //  覆盖goods和product
                    meta_content['product_wechatgame'] = dataMap.get('product_allplatform')
                    meta_content['goods'] = dataMap.get('goods')

                    if (global.mini && mini.getPlatform() === MiniPlatform.qqlightGame) {
                        console.log("[#########]user qqlight product")
                        for (var item in meta_content['product_wechatgame']) {
                            if (meta_content['product_wechatgame'][item].productId['qq_lightgame']) {
                                meta_content['product_wechatgame'][item].productId = meta_content['product_wechatgame'][item].productId['qq_lightgame']
                            } else {
                                meta_content['product_wechatgame'][item].show = 0
                            }
                        }
                    } else if (global.mini && mini.getPlatform() == MiniPlatform.oppoQuickgame){
                        console.log("[#########]user oppoquickgame product")
                        for (var item in meta_content['product_wechatgame']) {
                            if (meta_content['product_wechatgame'][item].productId['oppo_quickgame']) {
                                meta_content['product_wechatgame'][item].productId = meta_content['product_wechatgame'][item].productId['oppo_quickgame']
                            } else {
                                meta_content['product_wechatgame'][item].show = 0
                            }
                        }
                    }else if (global.mini && mini.getPlatform() == MiniPlatform.honorQuickgame){
                        console.log("[#########]user honorquickgame product")
                        for (var item in meta_content['product_wechatgame']) {
                            if (meta_content['product_wechatgame'][item].productId['honor_quickgame']) {
                                meta_content['product_wechatgame'][item].productId = meta_content['product_wechatgame'][item].productId['honor_quickgame']
                            } else {
                                meta_content['product_wechatgame'][item].show = 0
                            }
                        }
                    }else if (global.mini && mini.getPlatform() == MiniPlatform.baidu){
                        console.log("[#########]user baidu product")
                        for (var item in meta_content['product_wechatgame']) {
                            if (meta_content['product_wechatgame'][item].productId['baidu_lightgame']) {
                                meta_content['product_wechatgame'][item].productId = meta_content['product_wechatgame'][item].productId['baidu_lightgame']
                            } else {
                                meta_content['product_wechatgame'][item].show = 0
                            }
                        }
                    } else if (global.mini && mini.getPlatform() == MiniPlatform.wechatgame){ 
                        for (var item in meta_content['product_wechatgame']) {
                            if (meta_content['product_wechatgame'][item].productId['wechatgame']) {
                                meta_content['product_wechatgame'][item].productId = meta_content['product_wechatgame'][item].productId['wechatgame']
                            } else {
                                meta_content['product_wechatgame'][item].show = 0
                            }
                        }
                    }else if (global.mini && mini.getPlatform() == MiniPlatform.vivo){
                        console.log("[#########]user vivoquickgame product")
                        for (var item in meta_content['product_wechatgame']) {
                            if (meta_content['product_wechatgame'][item].productId['vivo_quickgame']) {
                                meta_content['product_wechatgame'][item].productId = meta_content['product_wechatgame'][item].productId['vivo_quickgame']
                            } else {
                                meta_content['product_wechatgame'][item].show = 0
                            }
                        }
                    } else if (global.mini && mini.getPlatform() == MiniPlatform.tt){
                        console.log("[#########]user ttlightgame product")
                        for (var item in meta_content['product_wechatgame']) {
                            if (meta_content['product_wechatgame'][item].productId['douyin_game']) {
                                meta_content['product_wechatgame'][item].productId = meta_content['product_wechatgame'][item].productId['douyin_game']
                            } else {
                                meta_content['product_wechatgame'][item].show = 0
                            }
                        }
                    } else if (getCurrentPlatform() == XcloverPlatform.huawei){
                        console.log("[#########]user huawei product")
                        for (var item in meta_content['product_wechatgame']) {
                            if (meta_content['product_wechatgame'][item].productId['huawei_quickgame']) {
                                meta_content['product_wechatgame'][item].productId = meta_content['product_wechatgame'][item].productId['huawei_quickgame']
                            } else {
                                meta_content['product_wechatgame'][item].show = 0
                            }
                        }
                    } else if (global.mini && getCurrentPlatform() == MiniPlatform.mi){
                        console.log("[#########]user mi product")
                        for (var item in meta_content['product_wechatgame']) {
                            if (meta_content['product_wechatgame'][item].productId['mi_quickgame']) {
                                meta_content['product_wechatgame'][item].productId = meta_content['product_wechatgame'][item].productId['mi_quickgame']
                            } else {
                                meta_content['product_wechatgame'][item].show = 0
                            }
                        }
                    }else {
                        //  玩吧和微信的productId一样
                        for (var item in meta_content['product_wechatgame']) {
                            if (meta_content['product_wechatgame'][item].productId['wechatgame']) {
                                meta_content['product_wechatgame'][item].productId = meta_content['product_wechatgame'][item].productId['wanba_ts']
                            } else {
                                meta_content['product_wechatgame'][item].show = 0
                            }
                        }

                    }


                    meta_content['product'] = meta_content['product_wechatgame']

                    CfgManager.release("goods","product_wechatgame","product_qq_lightgame","product_oppo_quickgame", "product_baidu_lightgame", "game", "product_allplatform", "prop", "subscribe_msg", "new_ad_config")

                    for (var k in MetaKeyClassList) {
                        var v = MetaKeyClassList[k]
                        if (v.cls) {
                            self[v.key] = parseItemDict(meta_content, v.key, v.cls)
                            cc.log("parse item def:" + v.key)
                        } else {
                            cc.log("parseItemDict: " + v.key)
                            debug.debug()
                        }
                    }
                    
                    self.levelRewardMap = {}
                    for (let key in self.level_reward) {
                        let reward = self.level_reward[key]
                        if (reward.levelId) {
                            self.levelRewardMap[reward.levelId] = reward
                        }
                    }
                    // TODO: loadFrom network
                    MaintenanceManager.getInstance().loadFromMetaClient()
              })
    
}
MetaManager.inviteReward_getInviteRewardMetaById = function (id) {
    var __VA_ARG = $slice(arguments, 1)
    var self = this
    assert(type(id) === "number")
    assert($len(table([2, __VA_ARG])) === 0)
    for (var k in self.invite_reward) {
        var v = self.invite_reward[k]
        if (v.id === id) {
            return v
        }
    }
    return false
}
MetaManager.HeadFrameMeta_getFrameMeta = function (id) {
    var self = this
    for (var k in self.head_frame) {
        var v = self.head_frame[k]
        if (v.id === id) {
            return v
        }
    }
    return null
}
MetaManager.headFrameMeta_getFrameIdByMainLevel = function (level) {
    var self = this
    table.sort(self.head_frame, function (a, b) {
        return a.totalLevel < b.totalLevel
    })
    var $var24 = $len(self.head_frame)
    for (var i = $var24; i >= 1; i += -1) {
        var v = self.head_frame[i]
        if (!v) {
            continue
        }
        if (level >= v.totalLevel) {
            return v.id
        }
    }
    return 0
}
// MetaManager.ladybugReward_getLadyBugRewardMeta = function (taskId) {
//     var __VA_ARG = $slice(arguments, 1)
//     var self = this
//     assert(type(taskId) === "number")
//     assert($len(table([2, __VA_ARG])) === 0)
//     for (var k in self.ladybug_reward) {
//         var v = self.ladybug_reward[k]
//         if (v.id === taskId) {
//             return v
//         }
//     }
//     return false
// }
// MetaManager.starReward_getRewardLevel = function (starNum) {
//     var __VA_ARG = $slice(arguments, 1)
//     var self = this
//     assert(type(starNum) === "number")
//     assert($len(table([2, __VA_ARG])) === 0)
//     var nearestLevel = false
//     for (var k = 1, v = self.star_reward[1]; v; k++ , v = self.star_reward[k]) {
//         if (starNum >= v.starNum) {
//             if (!nearestLevel || nearestLevel.starNum < v.starNum) {
//                 nearestLevel = v
//             }
//         }
//     }
//     return nearestLevel
// }
// MetaManager.starReward_getNextRewardLevel = function (starNum) {
//     var __VA_ARG = $slice(arguments, 1)
//     var self = this
//     assert(type(starNum) === "number")
//     assert($len(table([2, __VA_ARG])) === 0)
//     var nextNearestLevel = false
//     for (var k = 1, v = self.star_reward[1]; v; k++ , v = self.star_reward[k]) {
//         if (starNum < v.starNum) {
//             if (!nextNearestLevel || nextNearestLevel.starNum > v.starNum) {
//                 nextNearestLevel = v
//             }
//         }
//     }
//     return nextNearestLevel
// }
// MetaManager.starReward_getStarRewardMetaById = function (id) {
//     var __VA_ARG = $slice(arguments, 1)
//     var self = this
//     assert(type(id) === "number")
//     assert($len(table([2, __VA_ARG])) === 0)
//     for (var k = 1, v = self.star_reward[1]; v; k++ , v = self.star_reward[k]) {
//         assert(type(v.id) === "number")
//         if (v.id === id) {
//             return v
//         }
//     }
//     return false
// }
MetaManager.getMaxFriendCount = function () {
    var self = this
    return 200
}
MetaManager.isMaxLevelAreaId = function (levelId) {
    let self = this
    for (let i in self.level_area) {
        let v = self.level_area[i]
        if ($null(v)) continue
        if (v.maxLevel === levelId) {
            return true
        }
    }
    return false
}
MetaManager.isMinLevelAreaId = function (levelId) {
    var self = this
    for (var i in self.level_area) {
        var v = self.level_area[i]
        if (v.minLevel === levelId) {
            return true
        }
    }
    return false
}
MetaManager.getLevelAreaById = function (levelId) {
    var self = this
    return self.level_area[levelId]
}
MetaManager.getCoinBlockersByLevelId = function (levelId) {
    var self = this
    return self.coin_blocker[levelId]
}
MetaManager.getPropMetaRef = function () {
    var self = this
    return self.prop
}
MetaManager.getPropMeta = function (propId) {
    var self = this
    if (self && self.prop) {
        return self.prop[propId]
    }else{
        console.warn(`self.prop is null or undefined`)
    }
    return null
}
MetaManager.getGoodsMetaRef = function () {
    var self = this
    return self.goods
}
MetaManager.getGoodsMeta = function (goodId) {
    var self = this
    let conf = self.goods[goodId];
    if (!conf && PiggyBankManager){
        conf = PiggyBankManager.getInstance().getGoodsMetaByID(goodId);
    }
    return conf;
}
MetaManager.updateGoodsMeta = function (goodsId, metaRef) {
    var self = this
    cc.log("[####]goods ", self.goods)
    self.goods[goodsId] = metaRef
}
MetaManager.getGoodPayCodeMeta = function (goodId) {
    var self = this
    return self.goods_pay_code[goodId]
}
MetaManager.goodsIdToProductId = function (goodsId) {
    var self = this
    var metaList
    if (__ANDROID) {
        metaList = self.product_android
    } else if (META.platform == XcloverPlatform.wechatgame) {
        metaList = self.product_wechatgame
    } else if (__IOS || __WIN32) {
        metaList = self.product
    } else {
        assert(false, "not support platform")
    }
    if (metaList) {
        var meta = table.find(metaList, function (v) {
            return goodsId === v.goodsId
        })[0]
        if (meta) {
            return meta.id
        }
    }
    return null
}
MetaManager.productIdToId = function (productId) {
    var self = this
    var metaList
    if (__ANDROID) {
        metaList = self.product_android
    } else if (META.platform == XcloverPlatform.wechatgame) {
        metaList = self.product_wechatgame
    } else if (__IOS || __WIN32) {
        metaList = self.product_wechatgame
    } else {
        assert(false, "not support platform")
    }
    if (metaList) {
        var meta = table.find(metaList, function (v) {
            return productId === v.productId
        })[0]
        if (meta) {
            return meta.id
        }
    }
    return null
}
MetaManager.getProductAndroidMeta = function (goodId) {
    var self = this
    return self.product_android[goodId]
}
MetaManager.updateProductAndroidMeta = function (productId, metaRef) {
    var self = this
    self.product_android[productId] = metaRef
}

MetaManager.updateProductMetaByPlatform = function (productId, metaRef) {
    var self = this
    var metaList
    if (__ANDROID) {
        metaList = self.product_android
    } else if (META.platform == XcloverPlatform.wechatgame) {
        metaList = self.product_wechatgame
    } else if (__IOS || __WIN32) {
        console.log("[####]update productmeta ios|win32 ")
        metaList = self.product
    } else {
        console.log("[####]update productmeta null ")
        assert(false, "not support platform")
        return
    }
    metaList[productId] = metaRef
    cc.log("[####]meta list: ",  metaList)
}

MetaManager.updateProductMeta = function (productId, metaRef) {
    var self = this
    self.product[productId] = metaRef
}


MetaManager.getGoodMetaByItemID = function (itemId) {
    var self = this
    for (var k in self.goods) {
        var v = self.goods[k]
        //RewardItemRef
        if ($len(v.items) === 1 && v.items[1].itemId === itemId) {
            return v
        }
    }
    return null
}
MetaManager.getLevelRewardByLevelId = function (levelId) {
    return this.levelRewardMap[levelId] || null
}
MetaManager.getLevelDefaultRewards = function (levelId) {
    return LevelRewardMetaRef.prototype.getDefaultRewards.call(null, levelId)
}
MetaManager.getLevelNewStarRewards = function (star, levelId) {
    return LevelRewardMetaRef.prototype.getNewStarRewards.call(null, star, levelId)
}
MetaManager.getIsGuideByLevelId = function (levelId) {
    let levelData = this.levelRewardMap[levelId]
    if (levelData) {
        return levelData.guide
    }
    return false
}
MetaManager.getMarkConfig = function () {
    var self = this
    // WARN: maybe multi result
    return clone(self.mark)
}
MetaManager.getMarkByNum = function (markNum) {
    var self = this
    return self.mark[markNum]
}
MetaManager.getGameModePropByModeId = function (gameMode) {
    var self = this
    return self.gamemode_prop[gameMode]
}
/**
 * 设置主线关卡的关前道具设置
 */
MetaManager.setGameModeInitProp = function (data) {
    var self = this
    for (var i in self.gamemode_prop) {
        self.gamemode_prop[i].initProps_item = data
    }
}
MetaManager.getLevelAreaRefByLevelId = function (levelId) {
    var self = this
    assert(type(levelId) === "number")
    for (var k in self.level_area) {
        var v = self.level_area[k]
        if (tonumber(v.minLevel) <= levelId && levelId <= tonumber(v.maxLevel)) {
            return v
        }
    }
    return null
}
MetaManager.getIntroMeta = function () {
    var self = this
    return self.intro
}
MetaManager.getIntroMetaCount = function () {
    var self = this
    var count = 0
    for (var k in self.intro) {
        var v = self.intro[k]
        if (v.unlockLevel < 9999) {
            count = count + 1
        }
    }
    return count
}
MetaManager.getIntrosByCategory = function (category) {
    var self = this
    var intros = table()
    for (var k = 1, v = self.intro[1]; v; k++ , v = self.intro[k]) {
        if (v.category === category) {
            table.insert(intros, v)
        }
    }
    return intros
}
MetaManager.getNextLevelAreaRefByLevelId = function (levelId) {
    var self = this
    var curLevelArea = self.getLevelAreaRefByLevelId(levelId)
    var nextLevelArea = null
    if (curLevelArea) {
        var curLevelAreaMaxLevel = tonumber(curLevelArea.maxLevel)
        var nextLevelAreaMinLevel = curLevelAreaMaxLevel + 1
        nextLevelArea = self.getLevelAreaRefByLevelId(nextLevelAreaMinLevel)
    }
    return nextLevelArea
}
MetaManager.getMaxNormalLevelByLevelArea = function () {
    return UserManager.getInstance().getMaxLevelServer()
    // var self = this
    // var maxLevel = 0
    // for (var k in self.level_area) {
    //     var v = self.level_area[k]
    //     if (v.maxLevel > maxLevel && v.maxLevel < 9999) {
    //         maxLevel = v.maxLevel
    //     }
    // }
    // return maxLevel
}
MetaManager.getTaskLevelId = function (areaId) {
    var self = this
    for (var k in self.level_area) {
        var v = self.level_area[k]
        if (tonumber(areaId) === tonumber(v.id)) {
            return v.unlockTaskLevelId
        }
    }
}
MetaManager.isTaskCanUnlockLevalArea = function (areaId) {
    var self = this
    if (self.getTaskLevelId(areaId)) {
        return true
    } else {
        return false
    }
}
MetaManager.getAreaIdByTaskLevelId = function (taskLevelId) {
    var self = this
    for (var k in self.level_area) {
        var v = self.level_area[k]
        if (v.unlockTaskLevelId && v.unlockTaskLevelId === taskLevelId) {
            return v.id
        }
    }
}
MetaManager.getGiftBlockerByLevelId = function (levelId) {
    var self = this
    if (self.gift_blocker) {
        for (var k in self.gift_blocker) {
            var v = self.gift_blocker[k]
            if (v.level === levelId) {
                return v
            }
        }
    }
    return null
}

MetaManager.getRankVisible = function () {
    return this.global.displayRank
}

MetaManager.getEnterInviteCodeReward = function () {
    var self = this
    return self.global.enter_invite_code_reward
}
MetaManager.getInitBagSize = function () {
    var self = this
    return self.global.initBagSize
}
MetaManager.getBagCapacity = function () {
    var self = this
    return self.global.bag_capacity
}
MetaManager.getAnimalInviteRewardRatio = function () {
    var self = this
    return self.global.animal_invite_reward_ration
}
MetaManager.getAnimalInviteReward = function () {
    var self = this
    return self.global.animal_invite_rewards
}
MetaManager.getFriendCouponMeta = function () {
    var self = this
    return self.coupon
}
MetaManager.getRewardsById = function (id) {
    var self = this
    if (self.rewards && self.rewards[id]) {
        return self.rewards[id].rewards
    }
}
MetaManager.getBetaUserReward = function () {
    var self = this
    return self.global.beta_user_reward
}
MetaManager.getCollectSeedRange = function () {
    let self = this
    // body
    return self.global.collect_seed_range
}
MetaManager.getBaseProductMetaByID = function (id) {
    let self = this
    let metaList = self.product
    for (var k in metaList) {
        var v = metaList[k]
        if (v && v.id === id) {
            return v
        }
    }
    return null
}
MetaManager.getProductMetaByID = function (id) {
    var self = this

    console.log("[####]get productMetaByID id " + id)
    var metaList
    if (__ANDROID) {
        metaList = self.product_android
    } else if (META.platform == XcloverPlatform.wechatgame) {
        metaList = self.product_wechatgame
    } else if (__IOS || __WIN32) {
        metaList = self.product
    } else {
        return null
    }

    for (var k in metaList) {
        var v = metaList[k]
        if (v.id === id) {
            return v
        }
    }
    // 进行透传数据处理 模拟商品配置表这里key使用 piggy_bank 确保唯一性
    if (PiggyBankManager){
        let msg = PiggyBankManager.getInstance().getProductMetaByID(id);
        if (msg) return msg;
    }

    return null
}
MetaManager.getDailyMaxSendGiftCount = function (topLevel) {
    var self = this
    var t = self.global.daily_max_send_gift_count
    var num = 0
    var vipMonth = UserManager.getInstance().isVipMonth() ? 10 : 0
    for (var k = 1, v = t[1]; v; k++ , v = t[k]) {
        num = v.num
        if (topLevel <= v.level) {
            return num + vipMonth
        }
    }
    return num + vipMonth
}
MetaManager.getDailyMaxReceiveGiftCount = function () {
    var self = this
    return self.global.daily_max_receive_gift_count
}
MetaManager.getFreegift = function (topLevel) {
    var self = this
    for (var k = 1, v = self.freegift[1]; v; k++ , v = self.freegift[k]) {
        if (topLevel <= v.maxLevel) {
            return v.reward[1]
        }
    }
    cc.log("Wrong toplevel!!")
    return null
}
MetaManager.getNextFreegift = function (topLevel) {
    var self = this
    for (var k = 1, v = self.freegift[1]; v; k++ , v = self.freegift[k]) {
        if (topLevel < v.level) {
            return [v.reward[1], v.level]
        }
    }
    if (found) {
        return [null]
    } else {
        cc.log("Wrong topLevel")
        return [null]
    }
}
MetaManager.getNewUserRewards = function () {
    var self = this
    return self.global.new_user_reward_normal
}
MetaManager.getFreegiftId = function (itemId, itemNum) {
    let self = this
    for (let k = 1, v = self.freegift[1]; v; k++, v = self.freegift[k]) {
        if (v.reward[1].itemId === itemId && v.reward[1].num === itemNum) {
            return v.id
        }
    }
    return 0
}
MetaManager.getSetShortcutRewards = function () {
    var self = this
    return self.global.shortcut_reward
}
MetaManager.getSetQzoneBackgroundRewards = function () {
    var self = this
    return self.global.qzone_background_reward
}
MetaManager.getDailyFirstShareRewards = function () {
    var self = this
    return self.global.daily_first_share_reward
}
MetaManager.getDailyShareRewardDelta = function () {
    var self = this
    return self.global.daily_share_reward_delta
}
MetaManager.getDailyShareCountLimit = function () {
    var self = this
    return self.global.daily_share_count_limit
}
MetaManager.getDailyShareRewardInfo = function () {
    var self = this
    let info = {
        "startReward": self.getDailyFirstShareRewards(),
        "delta": self.getDailyShareRewardDelta()
    }
    return info
}
MetaManager.getMarketConfig = function () {
    var self = this
    return self.market_config
}
MetaManager.getFruitGrowCycle = function () {
    var self = this
    return self.global.fruit_grow_cycle
}
MetaManager.getCrowCountNum = function () {
    var self = this
    return self.global.fruit_crow_count_num
}
MetaManager.getInviteFriendCount = function () {
    var self = this
    return self.global.invite_friends_count
}
MetaManager.getNewUserTaskMeta = function () { return null }
MetaManager.getMaxUseTime = function (levelId, propId) {
    var self = this
    for (var i = 1, v = self.prop_max_use[1]; v; i++ , v = self.prop_max_use[i]) {
        if (v.levelIdStart <= levelId && v.levelIdEnd >= levelId) {
            for (var k = 1, w = v.maxUseTime[1]; w; k++ , w = v.maxUseTime[k]) {
                if (w.itemId === propId) {
                    return w.num
                }
            }
            return 0
        }
    }
    return 0
}
MetaManager.getGuidePropMeta = function (metaId) {
    var self = this
    for (var i = 1, v = self.guide_prop[1]; v; i++ , v = self.guide_prop[i]) {
        if (metaId === v.id) {
            return v
        }
    }
    return null
}
MetaManager.getStarGroupById = function (id) {
    return null
}
MetaManager.getStarRewardById = function (id) {
    var self = this
    return self.star_reward[id]
}
MetaManager.getNextStarRewardID = function () {
    var self = this
    var maxGeted = 0
    var fetchedStarRewardIds = UserManager.getInstance().fetchedStarRewardIds
    if (fetchedStarRewardIds && type(fetchedStarRewardIds) === "table" && $len(fetchedStarRewardIds) > 0) {
        maxGeted = Math.max(...unpack(UserManager.getInstance().fetchedStarRewardIds))
    }
    var nextID = maxGeted + 1
    var data = self.getStarRewardById(nextID)
    if (data) {
        return nextID
    }
    return null
}
MetaManager.getMaintenance = function () {
    var self = this
    return self.maintenance
}
MetaManager.getWeekRankRewardsByRankID = function (rank, category) {
    let self = this
    rank = tonumber(rank) || 0
    let $st155 = self.weekly_match_rank_rewards || table()
    for (let k in $st155) {
        let v = $st155[k]
        if ($null(v)) continue
        if (rank >= v.range[1] && rank <= v.range[2] && category === v.category) {
            return v.rank_rewards
        }
    }
    return table()
}
MetaManager.getFriendCurrentRankGroupMax = function (rank) {
    let self = this
    rank = tonumber(rank) || 0
    let topRank = null
    let $st159 = self.weekly_match_rank_rewards || table()
    for (let k in $st159) {
        let v = $st159[k]
        if ($null(v)) continue
        if (rank >= v.range[1] && rank <= v.range[2] && 1 === v.category) {
            topRank = v.range[2]
            break
        }
    }
    return topRank
}
MetaManager.getFriendNextRankGroupMin = function (rank) {
    let self = this
    let topRank = self.getFriendCurrentRankGroupMax(rank)
    if (topRank) {
        topRank = topRank + 1
        if (self.getWeekRankRewardsByRankID(topRank, 1)) {
            return topRank
        }
    }
    return null
}
MetaManager.getFriendNextRankRewardsByRankID = function (rank) {
    let self = this
    let topRank = self.getFriendCurrentRankGroupMax(rank)
    if (topRank) {
        topRank = topRank + 1
        // WARN: maybe multi result
        return self.getWeekRankRewardsByRankID(topRank, 1)
    }
    return table()
}
MetaManager.getRewardContentByBoxID = function (id) {
    let self = this
    for (let k in self.weekly_match_rewards) {
        let v = self.weekly_match_rewards[k]
        if ($null(v)) continue
        if (v.id === id) {
            return v.rewards
        }
    }
    return table()
}
// MetaManager.getActivityRewardById = function (activityId) {
//     var self = this
//     activityId = tonumber(activityId)
//     for (let key in self.activity_rewards) {
//         let v = self.activity_rewards[key];
//         if (v && tonumber(v.activityId) === activityId) {
//             return clone(v.rewards)
//         }
//     }
//     return table()
// }
MetaManager.getWeekRankRewardsByRankID = function (rank, category) {
    let self = this
    rank = tonumber(rank) || 0
    return table()  //排行榜奖励去掉

    let $st155 = self.weekly_match_rank_rewards || table()
    for (let k in $st155) {
        let v = $st155[k]
        if ($null(v)) continue
        if (rank >= v.range[1] && rank <= v.range[2] && category === v.category) {
            return v.rank_rewards
        }
    }
    return table()
}
MetaManager.getFriendCurrentRankGroupMax = function (rank) {
    let self = this
    rank = tonumber(rank) || 0
    let topRank = null
    let $st159 = self.weekly_match_rank_rewards || table()
    for (let k in $st159) {
        let v = $st159[k]
        if ($null(v)) continue
        if (rank >= v.range[1] && rank <= v.range[2] && 1 === v.category) {
            topRank = v.range[2]
            break
        }
    }
    return topRank
}
MetaManager.getFriendNextRankGroupMin = function (rank) {
    let self = this
    let topRank = self.getFriendCurrentRankGroupMax(rank)
    if (topRank) {
        topRank = topRank + 1
        if (self.getWeekRankRewardsByRankID(topRank, 1)) {
            return topRank
        }
    }
    return null
}
MetaManager.getFriendNextRankRewardsByRankID = function (rank) {
    let self = this
    let topRank = self.getFriendCurrentRankGroupMax(rank)
    if (topRank) {
        topRank = topRank + 1
        // WARN: maybe multi result
        return self.getWeekRankRewardsByRankID(topRank, 1)
    }
    return table()
}
MetaManager.getRewardContentByBoxID = function (id) {
    let self = this
    for (let k in self.weekly_match_rewards) {
        let v = self.weekly_match_rewards[k]
        if ($null(v)) continue
        if (v.id === id) {
            return v.rewards
        }
    }
    return table()
}
MetaManager.getIconCfgByName = function (name) {
    let self = this
    for (let k in self.icon) {
        let v = self.icon[k]
        if ($null(v)) continue
        if (v.name === name) {
            return v
        }
    }
    return null
}
MetaManager.getWechatShareAppIds = function () {
    let self = this
    return self.share_platform
}
MetaManager.getActivityMissionRankRewardsByID = function (id) {
    return null
}
MetaManager.getActivityMissionRankRewardsByRankID = function (rank, category) {
    return table()
}
MetaManager.getLabels = function () {
    let self = this
    return self.labels
}
MetaManager.getLevelHardness = function (levelId) {
    let self = this
    return (self.level_difficulty[levelId] || table()).difficulty || 0
}
MetaManager.getActivityMissionRankRewardsMetaByRank = function (rank, category) {
    return null
}
MetaManager.validateGiftbagInfo = function (productId) {
    let self = this
    var productInfo = MetaManager.getInstance().getProductMetaByID(productId)
    if (productInfo) {
        var goodsInfo = MetaManager.getGoodsMeta(productInfo.goodsId)
        if (goodsInfo) {
            return true
        } else {
            return false
        }
    } else {
        return false
    }
}
MetaManager.setPrePropsGuideConfig = function (config) {
    this.prePropsGuideConfig = {}
    this.prePropsGuideConfig.ab_test_name = config.level_pre_item_unlock_ab_test_name
    this.prePropsGuideConfig.unlock_lv = config.level_pre_item_unlock_lv
}


MetaManager.setCashConfig = function (config) {
    let self = this
    var cashSupport = null
    if (isPlatformIOS()) {
        cc.log("IOS平台")
        cashSupport = config.ios_pay
    } else {
        cc.log("非IOS平台")
        cashSupport = config.android_pay
    }
    
    console.log("!!!!cashSupport", cashSupport)

    var newCashSupport = []
    if (cashSupport) {
        for (var i = 0; i < cashSupport.length; i++) {
            cashSupport[i] = cashSupport[i].split(':')
            newCashSupport[cashSupport[i][0]] = cashSupport[i][1]
        }
    } else {
        return
    }

    if (global.mini) {
        if (newCashSupport.hasOwnProperty(mini.getPlatform())) {
            self.supportCash = newCashSupport[mini.getPlatform()]
        } else {
            self.supportCash = false
            cc.log("未配置的平台，默认关闭，请联系产品配置相关开关")
        }
    } else {
        if (__DEV) {
            self.supportCash = newCashSupport["wechatgame"]
            cc.log("PC平台")
        } else {
            if (newCashSupport.hasOwnProperty(META.platform)) {
                self.supportCash = newCashSupport[META.platform]
            } else {
                self.supportCash = false
                cc.log("未配置的平台，默认关闭，请联系产品配置相关开关")
            }
            // self.supportCash = newCashSupport["wanba_ts"]
            // cc.log("玩吧平台")
        }
    }

    if (self.supportCash && self.supportCash == 1) {
        self.supportCash = true
        cc.log("当前平台可以充值")
    } else {
        self.supportCash = false
        cc.log("当前平台不可充值")
    }
}
/**
 * 当前环境是否支持充值（根据配置读取，而不是当前实际环境）
 */
MetaManager.isSupportCash = function () {
    let self = this
    //ios只看iospay
    if (isPlatformIOS()) {
        return UserManager.getInstance().canIosPay()
    }
    //android读配置
    if (self.supportCash) {
        return true
    } else {
        return false
    }
}
/**
 * 加载新版签到系统配置
 * @param 游戏通用配置表
 */
MetaManager.loadNewMarkConfig = function (config) {
    let self = this
    self.newMark = {}
    self.newMark.remark_ad_daily_limit = config.mark_ad_daily_limit;        //  每日看广告补签次数上限
    self.newMark.remark_cost = config.mark_supply_cost_happycoins;          //  补签消耗的风车币
    self.newMark.mark_reward = table();            
    self.newMark.mark_reward[1] = config.monday_mark_rewards;               //  周一签到奖励
    self.newMark.mark_reward[2] = config.tuesday_mark_rewards;              //  周二奖励
    self.newMark.mark_reward[3] = config.wednesday_mark_rewards;            //  周三奖励
    self.newMark.mark_reward[4] = config.thursday_mark_rewards;             //  周四奖励
    self.newMark.mark_reward[5] = config.friday_mark_rewards;               //  周五奖励
    self.newMark.mark_reward[6] = config.saturday_mark_rewards;             //  周六奖励
    self.newMark.mark_reward[7] = config.sunday_mark_rewards;               //  周日奖励
    self.newMark.mark_reward_full = config.constant_mark_rewards;           //  七天连签奖励
    
    self.newMark.mark_reward_ad = table()                                   //  视频签到奖励
    var adrewards = config.ad_mark_rewards.split(';')
    for (var i = 0; i < adrewards.length; i++) {
        var day = parseInt(adrewards[i].substring(0, adrewards[i].indexOf(':')))
        var data = adrewards[i].substring(adrewards[i].indexOf(':') + 1)
        data = data.substr(1, data.length - 2)
        data = data.split(',')
        var item = []
        for (var j = 0; j < data.length; j++) {
            var itemData = data[j].split(':')
            item[j] = {}
            item[j].id = itemData[0]
            item[j].num = itemData[1]
        }
        self.newMark.mark_reward_ad[day] = item
    }             
}
/**
 * 获取新版签到设置
 */
MetaManager.getNewMarkConfig = function () {
    let self = this
    return clone(self.newMark)
}

/**
 * 加载Banner广告配置
 * @param 游戏通用配置表
 */
MetaManager.loadBannerAdConfig = function(config) {
    let self = this;

    self.bannerAdConfig = {};
    var iphone6width = 375;
    var iphone6height = 667;

    //  检查当前设备分辨率是否满足Banner展示条件
    if ((display.width / display.height) / (iphone6width / iphone6height) >= 1.02) {
        self.bannerAdConfig.displayAllow = false
        console.log("当前设备分辨率不满足Banner展示要求")
    } else {
        self.bannerAdConfig.displayAllow = true
        console.log("当前设备分辨率满足Banner展示要求")

        self.bannerAdConfig.level = config.banner_ad_level;
        self.bannerAdConfig.ios_switch = config.banner_ad_ios_switch;
        let dateString = config.banner_ad_duration.split(',');
        self.bannerAdConfig.startTime = (new Date(dateString[0] + " GMT+0800")).getTime();
        self.bannerAdConfig.endTime = (new Date(dateString[1] + " GMT+0800")).getTime();
        self.bannerAdConfig.adIntervals = config.banner_ad_adIntervals;
        
        let bannerAdOff
        let bannerAdUnit
        if (global.mini && mini.getPlatform() == MiniPlatform.wechatGame) {
            console.log("当前为微信平台")
            bannerAdOff = config.banner_ad_off_wechatgame;
            bannerAdUnit = config.banner_ad_unit_wechatgame;
        } else if (global.mini && mini.getPlatform() === MiniPlatform.qqlightGame) {
            console.log("当前为QQ平台")
            bannerAdOff = config.banner_ad_off_qqlightgame;
            bannerAdUnit = config.banner_ad_unit_qqlightgame;
        } else if (global.mini && mini.getPlatform() == MiniPlatform.oppoQuickgame){
            console.log("当前为OPPO平台")
            //self.bannerAdConfig.displayAllow = false
            bannerAdOff = config.banner_ad_off_oppoquickgame;
            bannerAdUnit = config.banner_ad_unit_oppoquickgame;
        } else if (global.mini && mini.getPlatform() == MiniPlatform.honorQuickgame){
            console.log("当前为honor平台")
            self.bannerAdConfig.displayAllow = false
            bannerAdOff = null;
            bannerAdUnit = null;
        } else if (global.mini && mini.getPlatform() == MiniPlatform.baidu){
            console.log("当前为百度平台")
            self.bannerAdConfig.displayAllow = false
            bannerAdOff = null;
            bannerAdUnit = null;
        } else if (global.mini && mini.getPlatform() == MiniPlatform.vivo){
            console.log("当前为ViVO平台")
            //self.bannerAdConfig.displayAllow = false
            bannerAdOff = config.banner_ad_off_vivoquickgame;
            bannerAdUnit = config.banner_ad_unit_vivoquickgame;
        }else {
            //  玩吧
            console.log("当前为玩吧或华为平台")
            self.bannerAdConfig.displayAllow = false
            bannerAdOff = null;
            bannerAdUnit = null;
        }
        if (bannerAdOff != null && bannerAdUnit != null) {
            self.bannerAdConfig.pannelData = {};
            var pannelData = self.bannerAdConfig.pannelData
            for (var i = 0; i < bannerAdOff.length; i++) {
                var offString = bannerAdOff[i].split(':');
                var index = offString[0];
                pannelData[index] = {};
                pannelData[index].show = offString[1] == "0" ? false : true;
                pannelData[index].userGroup = [];
                pannelData[index].unit = 0;
            }
            for (var i = 0; i < config.banner_ad_usergroup.length; i++) {
                var userGroup = config.banner_ad_usergroup[i].split(':');
                for (var j = 1; j < userGroup.length; j++) {
                    pannelData[userGroup[j]].userGroup[userGroup[0]] = 1;
                }
            }
            for (var i = 0; i < bannerAdUnit.length; i++) {
                var unit = bannerAdUnit[i].split(':');
                pannelData[unit[0]].unit = unit[1];
            }
        }
    }
}

/**
 * 当前玩家在指定面板是否可以展示Banner广告
 * @param panel 展示面板
 */
MetaManager.canShowBannerAd = function(panel, bannerData) {
    let self = this;
    // 检测ios的banner开关
    if (isPlatformIOS() && self.bannerAdConfig.ios_switch == 0){
        cc.log("[banner] ios暂不开放banner广告",self.bannerAdConfig.ios_switch)
        return false
    }

    //  检查分辨率比率
    if (!self.bannerAdConfig.displayAllow) {
        console.log("分辨率不满足条件")
        return false;
    }

    //  检查等级条件
    if (UserManager.getInstance().getUserRef().getTopLevelId() < self.bannerAdConfig.level) {
        console.log("等级不满足条件，解锁等级：" + self.bannerAdConfig.level + "，当前等级：" + UserManager.getInstance().getUserRef().getTopLevelId());
        return false;
    }

    //  检查平台支持
    var tmpPos
    var tmpData
    if (window.mini && window.mini.getPlatform() == MiniPlatform.oppoQuickgame){
        tmpPos = self.getAdUnit(panel);
        tmpData = bannerData;
        console.warn("@@@@oppo check showbanner pos:", tmpPos, " uerData:", JSON.stringify(tmpData))
    }
    if (!SnsProxy.getInstance().allowBannerAd(tmpPos, tmpData)) {
        console.log("平台不支持Banner")
        return false;
    }

    //  检查有效期
    let time = Localhost.time()
    if (time < self.bannerAdConfig.startTime || time >= self.bannerAdConfig.endTime) {
        console.log("Banner不在有效期内，开始时间：" + self.bannerAdConfig.startTime + "，结束时间：" + self.bannerAdConfig.endTime + "，当前时间：" + time);
        return false
    }

    let unLimit = -1

    //  检查用户和面板配置
    if (self.bannerAdConfig.pannelData) {
        if (self.bannerAdConfig.pannelData[panel] && self.bannerAdConfig.pannelData[panel].show) {
            //  检查是否存在用户组限制
            if (self.bannerAdConfig.pannelData[panel].userGroup[unLimit]) {
                return self.bannerAdConfig;
            } else {
                //  检查当前用户组是否满足开启条件
                var userGroup = UserManager.getInstance().getUserExtendRef().payUser ? 1 : 0;
                if (self.bannerAdConfig.pannelData[panel].userGroup[userGroup]) {
                    return self.bannerAdConfig
                } else {
                    console.log("当前用户在当前面板不显示Banner")
                    return false
                }
            }
        } else {
            console.log("面板不满足开启条件，当前设置：" + self.bannerAdConfig.pannelData[panel]);
            return false;
        }
    } else {
        return false;
    }
}

MetaManager.loadGridAdConfig = function(config){
    let self = this;

    self.gridAdConfig = {};

    if (!config.grid_ad_level){
        self.gridAdConfig.gridOpen = [];
        self.gridAdConfig.userGroup = [];
        self.gridAdConfig.unitConfig = [];
        return
    }

    self.gridAdConfig.level = config.grid_ad_level;
    let dateString = config.grid_ad_duration.split(',');
    self.gridAdConfig.adRate = config.grid_ad_rate;
    self.gridAdConfig.videoLimit = config.gird_video_limit;
    self.gridAdConfig.startTime = (new Date(dateString[0] + " GMT+0800")).getTime();
    self.gridAdConfig.endTime = (new Date(dateString[1] + " GMT+0800")).getTime();
    self.gridAdConfig.videoToday = [];
    self.gridAdConfig.pay30day = false;


    // 不同界面的开关和是否充值用户的开关
    if (global.mini && mini.getPlatform() == MiniPlatform.wechatGame) {
        self.gridAdConfig.gridOpen = config.grid_ad_wechatgame;
        self.gridAdConfig.userGroup = config.grid_ad_usergroup;
        self.gridAdConfig.unitConfig = config.grid_ad_unit_wechatgame;
    }else{
        self.gridAdConfig.gridOpen = [];
        self.gridAdConfig.userGroup = [];
        self.gridAdConfig.unitConfig = [];
    }
}


MetaManager.canShowGridAd = function(panelName) {
    let self = this;

    var gridAdConfig = null;

    //  检查分辨率比率
    var iphone6width = 375;
    var iphone6height = 667;
    if ((display.width / display.height) / (iphone6width / iphone6height) >= 1.02) {
        cc.log("格子广告分辨率不满足");
        return null;
    }

    //  格子广告开启时段
    let time = Localhost.time()
    if (time < self.gridAdConfig.startTime || time >= self.gridAdConfig.endTime) {
        cc.log("格子广告不在有效期内");
        return null
    }

    // 检查界面格子广告开启
    var hasOpen = false;
    for(const key in self.gridAdConfig.gridOpen){
        var data = self.gridAdConfig.gridOpen[key];
        data = data.split(":");
        if (panelName == data[0] && data[1] == 1){
            hasOpen = true;
            break;
        }
    }
    if (!hasOpen){
        cc.log("该平台这个界面的格子广告没开");
        return null;
    }

    //  用户等级满足
    if (UserManager.getInstance().getUserRef().getTopLevelId() < self.gridAdConfig.level) {
        cc.log("格子广告等级不满足");
        return null;
    }

    // 用户类型开启格子广告
    var hasOpen = false;
    for (const key in self.gridAdConfig.userGroup) {
        var data = self.gridAdConfig.userGroup[key];
        data = data.split(":");
        if (data[0] == -1 || (self.gridAdConfig.pay30day && data[0] == 1) || (!self.gridAdConfig.pay30day && data[0] == 0)){
            // -1 是不限制用户，只有在-1里就开启
            for(var i = 1; i < data.length; i++){
                if (panelName == data[i]){
                    hasOpen = true;
                    break;
                }
            }
        }
        if (hasOpen){
            break;
        }
    }
    if (!hasOpen){
        cc.log("该用户类型这个界面的格子广告没开");
        return null;
    }

    // 24小时看视频次数
    var hasOpen = false;
    var videoToday = 0;
    var now = Localhost.time();
    var oneDay = 60*60*24*1000;
    for(var i = 0; i < self.gridAdConfig.videoToday.length; i++){
        if (now - self.gridAdConfig.videoToday[i] <= oneDay){
            videoToday += 1;
        }
    }
    cc.log("看过视频广告", videoToday, "视频广告限制", self.gridAdConfig.videoLimit)
    if (videoToday <= self.gridAdConfig.videoLimit){
        hasOpen = true;
    }
    if (!hasOpen){
        cc.log("观看视频广告数量超过限制不显示格子广告");
        return null;
    }

    // 70的概率
    if (Math.floor(Math.random()*100) >= self.gridAdConfig.adRate){
        cc.log("格子广告概率外");
        return null;
    }

    var h = 0;
    var x = 0
    var w = 375
    if (window.mini && mini.getSystemInfoSync){
        var info = mini.getSystemInfoSync();
        h = info.screenHeight - 110;
        if (info.screenWidth > w){
            x = (info.screenWidth-w)/2
        }else{
            w = info.screenWidth
        }
    }

    // 获取格子广告创建的配置
    for (const key in self.gridAdConfig.unitConfig) {
        const e = self.gridAdConfig.unitConfig[key].split(":");
        if (e[0] == panelName){
            gridAdConfig = {
                adUnitId: '',
                adTheme: '',
                gridCount: 5,
                style: {
                    left: x,
                    top: h,
                    width: w,
                    opacity: 0
                }
            }
            for(var i = 0; i < e.length; i++){
                gridAdConfig.adUnitId = e[1];
                gridAdConfig.adTheme = e[2];
                gridAdConfig.gridCount = parseInt(e[3]);
                gridAdConfig.style.opacity = parseFloat(e[4]);
            }
            break;
        }
    }

    return gridAdConfig
}

MetaManager.loadInterstitialAdConfig = function(config){
    let self = this;

    self.interstitialAdConfig = {};

    var hasConfig = config.inter_ad_level && window.mini && mini.supportInterstitialAd();

    if (hasConfig) {
        if (mini.getPlatform() == MiniPlatform.wechatGame && !config.inter_ad_wechatgame){
            hasConfig = false;
        }else if (mini.getPlatform() == MiniPlatform.qqlightGame && !config.inter_ad_qqlightgame){
            hasConfig = false;
        }else if (mini.getPlatform() == MiniPlatform.oppoQuickgame && !config.inter_ad_oppoquickgame){
            hasConfig = false;
        }else if (mini.getPlatform() == MiniPlatform.honorQuickgame && !config.inter_ad_honorquickgame){
            hasConfig = false;
        }else if (mini.getPlatform() == MiniPlatform.vivo && !config.inter_ad_vivoquickgame){
            hasConfig = false;
        }else if(mini.getPlatform() === MiniPlatform.baidu && !config.inter_ad_baidulightgame) {
            hasConfig = false;
        }
    }

    if (!hasConfig){
        self.interstitialAdConfig.level = null;
        self.interstitialAdConfig.videoLimit = [0, 0];
        self.interstitialAdConfig.adLimit = [];
        self.interstitialAdConfig.callbacksafe = 0;
        self.interstitialAdConfig.usergroup = [];
        self.interstitialAdConfig.videoToday = [];
        return
    }

    self.interstitialAdConfig.level = config.inter_ad_level;
    self.interstitialAdConfig.videoLimit = config.inter_video_limit;
    self.interstitialAdConfig.adLimit = [];
    var adLimit = config.inter_ad_limit;
    for(var i = 0; i < adLimit.length; i++){
        if (adLimit[i]){
            self.interstitialAdConfig.adLimit.push(adLimit[i].split(":"));
        }
    }
    self.interstitialAdConfig.callbacksafe = config.inter_ad_callbacksafe;
    self.interstitialAdConfig.usergroup = config.inter_ad_usergroup;
    self.interstitialAdConfig.videoToday = [];
    self.interstitialAdConfig.pay30day = false;
    var adUnit = null;
    if (window.mini){
        self.interstitialAdConfig.adUnit = [];
        if (mini.getPlatform() == MiniPlatform.wechatGame){
            adUnit = config.inter_ad_unit_wechatgame;
        }else if (mini.getPlatform() == MiniPlatform.qqlightGame){
            adUnit = config.inter_ad_unit_qqlightgame;
        }else if (mini.getPlatform() == MiniPlatform.oppoQuickgame){
            adUnit = config.inter_ad_unit_oppoquickgame;
        }else if (mini.getPlatform() == MiniPlatform.honorQuickgame){
            adUnit = config.inter_ad_unit_honorquickgame;
        }else if (mini.getPlatform() == MiniPlatform.vivo){
            adUnit = config.inter_ad_unit_vivoquickgame;
        }else if(mini.getPlatform() === MiniPlatform.baidu) {
            adUnit = config.inter_ad_unit_baidulightgame;
        }
        for(var i = 0; i < adUnit.length; i++){
            if (adUnit[i]){
                self.interstitialAdConfig.adUnit.push(adUnit[i].split(":"));
            }
        }
    }else{
        self.interstitialAdConfig.adUnit = [];
        adUnit = config.inter_ad_unit_wechatgame;
        for(var i = 0; i < adUnit.length; i++){
            if (adUnit[i]){
                self.interstitialAdConfig.adUnit.push(adUnit[i].split(":"));
            }
        }
    }
    self.interstitialAdConfig.adOpen = [];
    var adOpen = null;
    if (window.mini){
        if (mini.getPlatform() == MiniPlatform.wechatGame){
            adOpen = config.inter_ad_wechatgame;
        }else if (mini.getPlatform() == MiniPlatform.qqlightGame){
            // self.interstitialAdConfig.adOpen = config.inter_ad_qqlightgame;
            adOpen = config.inter_ad_qqlightgame;
        }else if (mini.getPlatform() == MiniPlatform.oppoQuickgame){
            adOpen = config.inter_ad_oppoquickgame;
        }else if (mini.getPlatform() == MiniPlatform.honorQuickgame){
            adOpen = config.inter_ad_honorquickgame;
        }else if (mini.getPlatform() == MiniPlatform.vivo){
            adOpen = config.inter_ad_vivoquickgame;
        }else if (mini.getPlatform() == MiniPlatform.baidu){
            adOpen = config.inter_ad_baidulightgame;
        }
        if (adOpen){
            for(var i = 0; i < adOpen.length; i++){
                if (adOpen[i]){
                    self.interstitialAdConfig.adOpen.push(adOpen[i].split(":"));
                }
            }
        }
    }

    cc.log("interstitialAdConfig", self.interstitialAdConfig)
}

MetaManager.canShowInterstitialAd = function(adName, startLevelCnt){
    var self = this;
    if (self.interstitialAdConfig.level == null) {
        cc.log("插屏广告没有配置");
        return null;
    }
    
    //  检查分辨率比率
    var iphone6width = 375;
    var iphone6height = 667;
    if ((display.width / display.height) / (iphone6width / iphone6height) >= 1.02) {
        cc.log("插屏广告分辨率不满足");
        return null;
    }

    // 开启等级
    var userLv = UserManager.getInstance().getUserRef().getTopLevelId();
    if (userLv < self.interstitialAdConfig.level) {
        cc.log("插屏广告等级不满足");
        return null;
    }

    var hasOpen = false;
    // 24小时看视频次数
    var videoToday = 0;
    var now = Localhost.time();
    var oneDay = 60*60*24*1000;
    for(var i = 1; i < self.interstitialAdConfig.videoToday.length; i++){
        if (now - self.interstitialAdConfig.videoToday[i] <= oneDay){
            videoToday += 1;
        }
    }
    cc.log("看过视频广告", videoToday, "视频广告限制", self.interstitialAdConfig.videoLimit)
    if (self.interstitialAdConfig.videoLimit[0] <= videoToday && videoToday <= self.interstitialAdConfig.videoLimit[1]){
        hasOpen = true;
    }
    if (!hasOpen){
        cc.log("观看视频广告数量超过限制不显示插屏广告");
        return null;
    }

    // 当日插屏次数
    var limit = 1;
    var startLevelCntLimit = 1;
    for(var i = 0; i < self.interstitialAdConfig.adLimit.length; i++){
        if (userLv < self.interstitialAdConfig.adLimit[i][0]){
            startLevelCntLimit = self.interstitialAdConfig.adLimit[i][1];
            limit = self.interstitialAdConfig.adLimit[i][2];
            break;
        }
    }
    if (startLevelCnt < startLevelCntLimit){
        cc.log("过关次数不到显示插屏广告的规定", startLevelCnt, startLevelCntLimit);
        return null;
    }
    if (self.interstitialAdConfig.adToday >= limit){
        cc.log("观看插屏广告数量超过限制不显示插屏广告", self.interstitialAdConfig.adToday, limit);
        return null;
    }

    // 登录时间间隔限制
    if (UserManager.getInstance().lastLoginSec == 0 || UserManager.getInstance().lastLoginSec > self.interstitialAdConfig.callbacksafe){
        cc.log("观看插屏广告登陆时间间隔超过限制", UserManager.getInstance().lastLoginSec, self.interstitialAdConfig.callbacksafe);
        return null;
    }

    // 广告位是否开启
    var adUnitId = null;
    var hasOpen = false;
    cc.log(self.interstitialAdConfig.adUnit)
    for(var i = 0; i < self.interstitialAdConfig.adUnit.length; i++){
        if (adName == self.interstitialAdConfig.adUnit[i][0]){
            adUnitId = self.interstitialAdConfig.adUnit[i][1];
            break;
        }
    }
    cc.log(self.interstitialAdConfig.adOpen)
    for(var i = 0; i < self.interstitialAdConfig.adOpen.length; i++){
        if (adName == self.interstitialAdConfig.adOpen[i][0] && self.interstitialAdConfig.adOpen[i][1] == 1){
            hasOpen = true;
            break;
        }
    }
    if (!hasOpen || !adUnitId){
        cc.log("插屏广告位没开");
        return null;
    }

    hasOpen = false;
    // 用户类型分组
    console.warn("是否30天内有付费", self.interstitialAdConfig.pay30day)
    console.warn(self.interstitialAdConfig.usergroup)
    for (const key in self.interstitialAdConfig.usergroup) {
        var data = self.interstitialAdConfig.usergroup[key];
        data = data.split(":");
        if (data[0] == -1 || (self.interstitialAdConfig.pay30day && data[0] == 1) || (!self.interstitialAdConfig.pay30day && data[0] == 0)){
            // -1 是不限制用户，只有在-1里就开启
            for(var i = 1; i < data.length; i++){
                if (adName == data[i]){
                    hasOpen = true;
                    break;
                }
            }
        }
        if (hasOpen){
            break;
        }
    }
    if (!hasOpen){
        cc.log("该用户类型这个界面的插屏广告没开");
        return null;
    }

    // if (adUnitId){
    let channelAdId = transAdIdForChannel("InterstitialAd")
    if (adUnitId && channelAdId){
        adUnitId = channelAdId
    }

    return adUnitId;
}

/**
 * 获取指定面板的广告位信息，没有则返回默认值0
 */
MetaManager.getAdUnit = function(panel) {
    let self = this;

    if (self.bannerAdConfig && self.bannerAdConfig.pannelData && self.bannerAdConfig.pannelData[panel]) {
        //巨量腾讯分banner广告位
        let channelAdId = transAdIdForChannel("BannerAd")
        if (self.bannerAdConfig.pannelData[panel].unit && channelAdId){
            return channelAdId
        }
        return self.bannerAdConfig.pannelData[panel].unit;
    }
}
/**
 * 获取订阅开关设置
 */
MetaManager.getSubscribeCfg = function () {

    /*return {
        "subscription_mark":1,
        "subscription_energy":1,
        "subscription_level":1
    }*/
    let self = this
    return self.subscribeOpenInfo
}

/**
 * 加载定向分享配置
 */
MetaManager.loadOrientedShareConfig = function(config) {
    let self = this

    self.orientedShareConfig = {};
    var data = null;

    //  检查当前平台是否开启定向分享
    if (global.mini && mini.getPlatform() == MiniPlatform.wechatGame) {
        console.log("微信平台启用定向分享");
        self.orientedShareConfig.supportShareToFriend = true;
        data = config.sharetofriend_switch_wechatgame;
    } else  {
        console.log("非微信平台，不启动定向分享");
        self.orientedShareConfig.supportShareToFriend = false;
    }

    //  如果当前平台启用定向分享，则读取定向分享配置
    if (self.orientedShareConfig.supportShareToFriend) {
        if (data) {
            self.orientedShareConfig.pannelData = {};
            var pannelData = self.orientedShareConfig.pannelData
            for (var i = 0; i < data.length; i++) {
                var offString = data[i].split(':');
                var index = offString[0];
                pannelData[index] = {};
                pannelData[index].show = offString[1] == "0" ? false : true;
                if (index == "passlevel_showoff") {
                    pannelData[index].groupName = config.passlevel_showoff_sharetofriend_group;
                }
            }
        } else {
            self.orientedShareConfig.supportShareToFriend = false;
        }
    }
}

/**
 * 是否支持定向分享功能
 */
MetaManager.supportShareToFriend = function () {
    let self = this;

    if (self.orientedShareConfig) {
        return self.orientedShareConfig.supportShareToFriend;
    } else {
        return false;
    }
}

/**
 * 获取定向分享组名称
 */
MetaManager.getOrientedShareGroupName = function (panelName) {
    let self = this;

    if (self.orientedShareConfig) {
        return self.orientedShareConfig.pannelData[panelName].groupName;
    } else {
        return null;
    }
}

/**
 * 加载通关奖励配置（主线关卡，双倍奖励）
 */
MetaManager.loadPassLevelRewardConfig = function (config) {
    let self = this;

    let cfg = {};

    cfg.shareLimit = config.level_bonus_share_limit || 0;
    cfg.shareEnerge = config.level_bonus_share_energy || 999; 
    cfg.shareUpdateLimit = [];
    
    if (config.level_bonus_limit_update) {
        for (let i = 0; i < config.level_bonus_limit_update.length; i++) {
            let strs = config.level_bonus_limit_update[i].split(':');
            cfg.shareUpdateLimit.push({
                num: strs[0],
                limit: strs[1]
            });
        }
    }

    self.passLevelRewardConfig = cfg;
}

/**
 * 获取指定分享次数的双倍奖励上限
 */
MetaManager.getPassLevelDoubleRewardLimit = function (times = 0) {
    let self = this;

    if (self.passLevelRewardConfig) {
        let config = self.passLevelRewardConfig.shareUpdateLimit;
        for (let i = config.length - 1; i >= 0 ; i--) {
            if (times >= config[i].num) {
                return config[i].limit;
            }
        }
    }

    return 0;
}

/**
 * 获取指定分享次数的升档所需剩余次数
 */
MetaManager.getPassLevelDoubleRewardNextLevelRemain = function (times = 0) {
    let self = this;

    if (self.passLevelRewardConfig) {
        let config = self.passLevelRewardConfig.shareUpdateLimit;
        for (let i = 0; i < config.length; i++) {
            if (times < config[i].num) {
                return (config[i].num - times);
            }
        }
    }

    return 0;
}

/**
 * 获取奖励次数最高级所需领奖次数
 */
MetaManager.getPassLevelDoubleRewardTopTimes = function() {
    let self = this;

    return self.passLevelRewardConfig.shareUpdateLimit[self.passLevelRewardConfig.shareUpdateLimit.length - 1].num || 0
}

/**
 * 当前环境是否支持礼包分享功能（根据配置读取，而不是当前实际环境）
 */
MetaManager.isSupportGiftBagShare = function () {
    let self = this

    return self.supportGiftBagShare || false;
}

/**
 * 加载Banner广告配置
 * @param 游戏通用配置表
 */
MetaManager.loadGiftBagConfig = function(config) {
    let self = this;

    if (config.invite_pack_on) {
        var support = config.invite_pack_on.split(',');
        if (global.mini) {
            if (support.includes(mini.getPlatform())) {
                self.supportGiftBagShare = true;
            } else {
                self.supportGiftBagShare = false;
                cc.log("未配置的平台，默认关闭，请联系产品配置相关开关")
            }
        } else {
            if (__DEV && support.includes("wechatgame")) {
                self.supportGiftBagShare = true;
            } else if (support.includes(META.platform)) {
                self.supportGiftBagShare = true;
            } else {
                self.supportGiftBagShare = false;
            }
        }
    } else {
        self.supportGiftBagShare = false;
        return
    }

    if (self.supportGiftBagShare) {
        cc.log("当前平台可以使用关末礼包分享功能")
    } else {
        cc.log("当前平台不可使用关末礼包分享功能")
    }
}

/**
 * 获取当前环境是否支持ios支付引导
 */
 MetaManager.isSupportPaymentGuide = function () {
    let self = this
    // console.log("pay", self.supportPaymentGuide, userLv, self.payment_guide_min_level)
    var userLv = UserManager.getInstance().getUserRef().getTopLevelId();
    if (self.supportPaymentGuide && userLv >= self.payment_guide_min_level){
        return true
    }else{
        return false
    }
}

/**
 * 读game配置设置当前环境是否支持ios支付引导
 */
MetaManager.setPaymentGuideConfig = function(config) {
    let self = this;
    // console.log("pay config", config)
    if (config.payment_guide_platform && config.payment_guide_min_level > -1) {
        self.payment_guide_min_level = config.payment_guide_min_level
        var support = config.payment_guide_platform.split(',');
        if (global.mini) {
            if (isPlatformIOS() && support.includes(mini.getPlatform())) {
                self.supportPaymentGuide = true;
            } else {
                self.supportPaymentGuide = false;
                // cc.log("未配置的平台，默认关闭，请联系产品配置相关开关")
            }
        } else if (__DEV){
            //网页测试
            self.supportPaymentGuide = true
            // if (__DEV && support.includes("wechatgame")) {
            //     self.supportPaymentGuide = true;
            // } else if (support.includes("wanba_ts")) {
            //     self.supportPaymentGuide = true;
            // } else {
            //     self.supportPaymentGuide = false;
            // }
        }
    } else {
        self.supportPaymentGuide = false;
        return
    }
}



/**
 * 设置真实分享配置
 * @param config 游戏配置
 */
MetaManager.setRealShareConfig = function(config) {
    let self = this;

    if (config.share_new_qqoff) {
        if (window.mini && mini.getPlatform() == MiniPlatform.qqlightGame) {
            console.log("当前平台支持真实分享");
            self.useRealShare = true;
            self.qqModuleUseRealShare = config.share_new_qqoff;
        } else {
            console.log("当前平台不支持真实分享");
            self.useRealShare = false;
            self.qqModuleUseRealShare = {};
        }
    } else {
        console.log("当前平台不支持真实分享");
        self.useRealShare = false;
        self.qqModuleUseRealShare = {};
    }
}

/**
 * 检查当前是否使用真实分享设置
 */
MetaManager.isUseRealShare = function() {
    let self = this;

    return self.useRealShare || false;
}

/**
 * 检查当前是否启用特殊模块的真是分享，若当前平台不可使用真实分享，则无论配置怎么配都返回false
 */
MetaManager.isUseRealShareOnSpecialModule = function(moduleName) {
    let self = this;

    if (self.isUseRealShare() && moduleName) {
        if (self.qqModuleUseRealShare[moduleName]) {
            return false;
        } else {
            return true;
        }
    } else {
        return false;
    }
}

/**
 * 检查当前是否启用特殊模块的真是分享，若当前平台不可使用真实分享，则无论配置怎么配都返回false
 */
MetaManager.setIslandUnlockConfig = function(config) {
    let self = this;

    //  配置切割
    let island_unlock_limit = [];
    let strs = config.island_unlock_limit.split(';');
    for (let i = 0; i < strs.length; i++) {
        let subStrs = strs[i].split(':');
        let key = subStrs[0];
        let data = subStrs[1].split(',');
        island_unlock_limit[key] = data;
    }

    islandConfig = {};

    //  平台相关配置
    let plantform = "wanba_ts";
    if (global.mini) {
        plantform = mini.getPlatform();
    }

    //  广告加速开关
    islandConfig.canWatchVideo = SnsProxy.getInstance().allowAd();
    if (islandConfig.canWatchVideo) {
        console.log("可以看广告的平台");
    } else {
        console.log("看不了广告");
    }

    //  邀请好友开关
    islandConfig.canUseInvite = false;
    if (getCurrentPlatformAllowShare()) {
        for (let i = 0; i < island_unlock_limit.invite.length; i++) {
            if (island_unlock_limit.invite[i] === plantform) {
                islandConfig.canUseInvite = true;
                console.log("支持好友分享");
                break;
            }
        }
    }

    //  感兴趣好友开关
    islandConfig.canUseInterestInvite = false;
    if (SnsProxy.getInstance().allowInteractiveInvite()) {
        for (let i = 0; i < island_unlock_limit.promot.length; i++) {
            if (island_unlock_limit.promot[i] === plantform) {
                console.log("支持感兴趣好友");
                islandConfig.canUseInterestInvite = true;
                break;
            }
        }
    }

    //  本地测试检查
    if (__DEV) {
        console.log("测试平台");
        //islandConfig.canUseInvite = false;
        //islandConfig.canWatchVideo = false;
    }

    //  分享时间
    islandConfig.share_time_limit = config.time_match_timer;

    //  金币解锁每小时费用
    islandConfig.island_unlock_cost = config.island_unlock_cost;

    //  解锁成功分享拉新奖励
    islandConfig.island_unlock_share_reward = config.island_share_reward && (config.island_share_reward.split(':'))[1];

    //  邀请加速
    islandConfig.island_unlock_share_speedup = config.island_unlock_share_speedup;

    //  看广告加速
    islandConfig.island_unlock_ad_speedup = config.island_unlock_ad_speedup;

    self.islandUnlockConfig = islandConfig;
}

MetaManager.setManualLocationConfig = function(config) {
    let manualLocationConfig = {}
    let plateform_arr = config.location_platform.split(',');
    manualLocationConfig.location_history_capacity = config.location_history_capacity;
    manualLocationConfig.location_history_expire_days = config.location_history_expire_days;

    manualLocationConfig.location_set_cd_days = config.location_set_cd_days;
    manualLocationConfig.location_platform_arr = plateform_arr
    
    this.manualLocationConfig = manualLocationConfig
    
}
MetaManager.getManualLocationConfig = function() {
    return this.manualLocationConfig
}

MetaManager.setDeleteAccountConfig = function(config) {
    let deleteAccountConfig = {}
    deleteAccountConfig.delete_countdown = config.delete_countdown
    deleteAccountConfig.delete_date = config.delete_date
    deleteAccountConfig.delete_switch = config.delete_switch
    deleteAccountConfig.delete_button_text = config.delete_button_text

    
    this.deleteAccountConfig = deleteAccountConfig
}

MetaManager.getDeleteAccountConfig = function() {
    return this.deleteAccountConfig 
}

MetaManager.setBonusSpeed = function(config) {
    let self = this
    self.bonusSpeed = config.level_over_accelerate
}

MetaManager.getBonusSpeed = function() {
    let self = this
    return self.bonusSpeed
}
MetaManager.setPurpleAmyMagicOpenGroup = function(config) {
    let self = this
    self.purple_amy_magic_open_group = config.purple_amy_magic_open_group
}
MetaManager.getPurpleAmyMagicOpenGroup = function() {
    let self = this
    return self.purple_amy_magic_open_group || "all"
}
MetaManager.setCdkeyPlatform= function(config) {
    let self = this
    self.redeem_code_platform = config.redeem_code_platform
}

MetaManager.getCdkeyPlatform= function() {
    return this.redeem_code_platform || "all"
}

MetaManager.setIosPayConfig = function(config) {
    let iosPayConfig = {}
    iosPayConfig.jump_applet = config.jump_applet || "release"

    this.iosPayConfig = iosPayConfig
}

MetaManager.getIosPayConfig = function() {
    return this.iosPayConfig 
}

MetaManager.setNewAdConfig = function(config) {
    let newAdConfig = {}
    for (const key in config) {
        newAdConfig[key] = config[key]
    }

    this.newAdConfig = newAdConfig
}

MetaManager.getNewAdConfig = function() {
    return this.newAdConfig 
}

MetaManager.setAdTagConfig = function(labelConfig,strategyConfig,strategyConfigB) {
    cc.log("MetaManager.setAdTagConfig ",labelConfig,strategyConfig,strategyConfigB)
    this.adLabelConfig = labelConfig
    this.adStrategyConfig = strategyConfig
    this.adStrategyConfigB = strategyConfigB

}
MetaManager.geAdLabelConfig = function() {
    return this.adLabelConfig 
}
MetaManager.geAdStrategyConfig = function() {
    return this.adStrategyConfig 
}
MetaManager.geAdStrategyConfigB = function() {
    return this.adStrategyConfigB 
}

MetaManager.setCubeAbTestConfig = function(config) {
    this.cubeABtestConfig = config
}
MetaManager.setBattlePassConfig = function(config) {
    this.battlePassConfig = config
}
MetaManager.setMysteryIslandConfig = function(config) {
    this.mysteryIslandConfig = config
}
MetaManager.setMonthTicketConfig = function(config) {
    this.monthTicketConfig = config
}


MetaManager.setMonthTicketAdLevel = function(config) {
    let self = this
    self.monthTicketAdLevel = config.monthticket_ad_begin_level
}
MetaManager.getMonthTicketAdLevel= function() {
    let self = this
    return self.monthTicketAdLevel || 200;
}

MetaManager.setDressConfig = function(config) {
    cc.log("[dress] setDressConfig ",config)
    this.dressConfig = config
}
MetaManager.getDressConfig = function() {
    return this.dressConfig || {}
}

MetaManager.setShopConfig = function(config) {
    cc.log("[shop] setShopConfig ",config)
    this.shopConfig = config
}
MetaManager.getShopConfig = function() {
    return this.shopConfig || {}
}

MetaManager.setPropConsumeValueConfig = function(config) {
    cc.log("setPropConsumeValueConfig ",config)
    // this.propConsumeValueConfig = config
    this.propConsumeValueConfig = PropConsumeValueMeta.create()
    this.propConsumeValueConfig.fromLua(config)
    cc.log("setPropConsumeValueConfig fromLua ",this.propConsumeValueConfig)

}
MetaManager.getPropConsumeValueConfig = function() {
    return this.propConsumeValueConfig || {}
}

MetaManager.setRewardConvertConfig = function(config) {
    cc.log("setRewardConvertConfig ",config)
    this.rewardConvertConfig = config
}
MetaManager.getRewardConvertConfig = function() {
    return this.rewardConvertConfig || {}
}
MetaManager.getPropConsumeValue = function (propId) {
    let self = this
    if (!self.propConsumeValueConfig.propConsumeValueList) {
        return 0
    }
    let valueList = self.propConsumeValueConfig.propConsumeValueList
    return valueList[propId] || 0
}

MetaManager.setGameCfg = function(config) {
    this.gameCfg = config
}
MetaManager.getGameCfg = function() {
    return this.gameCfg || {}
}

MetaManager.setGameReviveCfg = function(config) {
    let self = this
    self.exitGameActivitySort = config.exit_game_activity_sort
    self.exitGameRewardSort = config.exit_game_reward_sort
    self.exitGameCube = config.game_revive_panel_ab_test_name3;
}
MetaManager.getGameReviveCfg = function() {
    let self = this
    return [self.exitGameActivitySort,self.exitGameRewardSort];
}

/**
 * 获取区域解锁配置
 */
MetaManager.getIslandUnlockConfig = function() {
    let self = this;

    if (self.islandUnlockConfig) {
        return self.islandUnlockConfig;
    } else {
        return {
            canWatchVideo: SnsProxy.getInstance().allowAd(),
            canUseInvite : SnsProxy.getInstance().allowShare(),
            canUseInterestInvite : window.mini && window.mini.supportInteractiveInvite(),
            share_time_limit : 2800,
            island_unlock_cost : 5,
            island_unlock_ad_speedup : 14400,
            island_unlock_share_speedup : 43200,
            island_unlock_share_reward : 50
        }
    }
}

// // 获取掉落干预配置（新老共用）
// MetaManager.getDropAdjustMeta = function () {
//     let self = this
//     return self.dropAdjust
// }
// 获取202206掉落干预难度标签配置
MetaManager.getDropAdjustDiffTagV2Meta = function () {
    let self = this
    return self.dropAdjustDiffTagV2
}
// // 获取202206掉落干预方案总表标签配置
// MetaManager.getDropAdjustPlanV2Meta = function () {
//     let self = this
//     return self.dropAdjustPlanV2
// }


MetaManager.setAmyGiftCube = function (config){
    let self = this;
    self.purple_amy_gift_ab_test_name = config.purple_amy_gift_ab_test_name;
}

MetaManager.setPopoutSceneCfg = function(cfg) {
    let self = this;
    self.popout_scene_cfg = cfg;
}
MetaManager.getPopoutSceneCfg = function() {
    let self = this;
    return self.popout_scene_cfg
}
MetaManager.setPopoutActivityCfg = function(cfg) {
    let self = this;
    self.popout_activity_cfg = cfg;
}
MetaManager.getPopoutActivityCfg = function() {
    let self = this;
    return self.popout_activity_cfg
}